import { render, staticRenderFns } from "./prizeList.vue?vue&type=template&id=156cb272&scoped=true"
import script from "./prizeList.vue?vue&type=script&lang=js"
export * from "./prizeList.vue?vue&type=script&lang=js"
import style0 from "./prizeList.vue?vue&type=style&index=0&id=156cb272&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156cb272",
  null
  
)

export default component.exports